import axios from '@/axios'
import helper from './helper'

const urlPrefix = 'leaderboards'

export default {
  getLeaderboard(criteria) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${ urlPrefix }/get-leaderboard`, criteria)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  addEntry(entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${ urlPrefix }`, entry)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateEntry(entry) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${ urlPrefix }/${ entry._id }`, entry)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  removeEntry(entry) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${ urlPrefix }/${ entry._id }`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  export(criteria) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${ urlPrefix }/export`, {
          event: criteria.event,
          entrytype: criteria.entrytype,
          category: criteria.category,
          gender: criteria.gender
        })
        .then(() => {
          window.location =
            axios.defaults.baseURL +
            '/admin/download-export/leaderboard-' +
            criteria.event +
            criteria.entrytype +
            criteria.category +
            criteria.gender
          resolve()
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  importEntries(criteria, entries) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${ urlPrefix }/bulk-add`, {
          event: criteria.event,
          entrytype: criteria.entrytype,
          category: criteria.category,
          gender: criteria.gender,
          entries: entries
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  reviewScore(
    id,
    evententry,
    event,
    score,
    tiebreaker,
    workout,
    scaled,
    notapproved,
    validated,
    notes
  ) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${ urlPrefix }/review-score/${ evententry }`, {
          evententry: evententry,
          event: event,
          score: score,
          tiebreaker: tiebreaker,
          workout: workout,
          scaled: scaled,
          notapproved: notapproved,
          validated: validated,
          notes: notes
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updateScore(id, evententry, event, score, tiebreaker, workout, scaled) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${ urlPrefix }/update-score/${ id }`, {
          evententry: evententry,
          event: event,
          score: score,
          tiebreaker: tiebreaker,
          workout: workout,
          scaled: scaled
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  async clearScore(id, workoutname) {
    return await helper.post(`${ urlPrefix }/clear-score/${ id }`, {
      workoutname: workoutname
    })
  },
  async getSavedHeats(event, entrytype, category, gender, workoutid) {
    return await helper.post(`${ urlPrefix }/get-heats-2`, {
      event: event,
      entrytype: entrytype,
      category: category,
      gender: gender,
      workoutid: workoutid
    })
  },
  async updateHeats(heats) {
    return await helper.put(
      `${ urlPrefix }/update-heats/${ heats.workoutid }`,
      heats
    )
  },
  async populateLeaderboard(id) {
    return await helper.post(
      `${ urlPrefix }/populate-event/${ id }`,
      {}
    )
  },
  async generateHeats(
    event,
    entrytype,
    category,
    gender,
    workoutname,
    workoutid
  ) {
    return await helper.post(`${ urlPrefix }/generate-heats`, {
      event: event,
      entrytype: entrytype,
      category: category,
      gender: gender,
      workout: workoutname,
      workoutid: workoutid
    })
  }
}
